(function()
{
	var Application = include('springroll.Application');
	var Container = include('PIXI.Container');
	var Debug = include('springroll.Debug', false);
	var Ease = include('createjs.Ease');
	var Point = include('PIXI.Point');
	var Tween = include('createjs.Tween');

	var Camera = function()
	{
		this.target = null;

		/**
		 * Reference to the application
		 * @property {springroll.Application} app
		 */
		this.app = Application.instance;

		/**
		 * Controls where the camera is? 
		 */
		this.targetOffset = 0;

		this.world = null;

		this.viewport = {
			left: 0,
			right: 0
		};

		this.updateCallback = this.update.bind(this);
	};

	var p = Camera.prototype = {};

	p.update = function()
	{
		var prevWorldPos = -this.world.x;
		this.world.x = -this.target.x + this.targetOffset;
		var diff = -this.world.x - prevWorldPos;
		this.scrollingBackground.pan(diff);

		this.viewport.left = -this.world.x;
		this.viewport.right = this.viewport.left + this.app.display.width / this.app.scaling.scale;
	};

	p.destroy = function()
	{
		this.world = null;
		this.target = null;
		this.targetOffset = null;
		this.updateCallback = null;
	};

	namespace('nature').Camera = Camera;
}());